import { ReturnsFacets, ReturnType } from "@redotech/redo-model/return";
import {
  ExchangePaymentStatus,
  ReviewingPartyFilter,
} from "@redotech/redo-model/return-search-filters";
import { RedoMerchantClient } from "../client";

/**
 * GET /returns/facets
 */
export async function getReturnsFacets(
  client: RedoMerchantClient,
  {
    search,
    dateRange,
    returnType,
    exchangePaymentStatus,
    type = "return",
    email,
    reviewingParty,
    signal,
  }: {
    search?: string;
    returnType?: string;
    exchangePaymentStatus?: ExchangePaymentStatus;
    dateRange?: string;
    type?: ReturnType;
    reviewingParty?: ReviewingPartyFilter;
    email?: string;
    signal?: AbortSignal;
  },
): Promise<ReturnsFacets> {
  const response = await client.client.get("returns/facets", {
    headers: client.authorization(),
    params: {
      search,
      type,
      returnType,
      dateRange,
      exchangePaymentStatus,
      email,
      reviewingParty,
    },
    signal,
  });
  return response.data;
}
